export default __webpack_public_path__ + "static/media/new-window-icon.1a6d0d1f.svg";